function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 14H10V15.5C10 15.7652 10.1054 16.0196 10.2929 16.2071C10.4804 16.3946 10.7348 16.5 11 16.5C11.2652 16.5 11.5196 16.3946 11.7071 16.2071C11.8946 16.0196 12 15.7652 12 15.5V14H13.5C13.7652 14 14.0196 13.8946 14.2071 13.7071C14.3946 13.5196 14.5 13.2652 14.5 13C14.5 12.7348 14.3946 12.4804 14.2071 12.2929C14.0196 12.1054 13.7652 12 13.5 12H12V10.5C12 10.2348 11.8946 9.98043 11.7071 9.79289C11.5196 9.60536 11.2652 9.5 11 9.5C10.7348 9.5 10.4804 9.60536 10.2929 9.79289C10.1054 9.98043 10 10.2348 10 10.5V12H8.5C8.23478 12 7.98043 12.1054 7.79289 12.2929C7.60536 12.4804 7.5 12.7348 7.5 13C7.5 13.2652 7.60536 13.5196 7.79289 13.7071C7.98043 13.8946 8.23478 14 8.5 14Z",
  fill: "#189BC5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 14L17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12L19 12C19.5523 12 20 11.5523 20 11L20 3C20 2.44772 19.5523 2 19 2L3 2C2.44771 2 2 2.44772 2 3L2 11C2 11.5523 2.44771 12 3 12L5 12C5.55228 12 6 12.4477 6 13C6 13.5523 5.55228 14 5 14L3 14C1.34314 14 -1.78993e-06 12.6569 -1.64508e-06 11L-9.45698e-07 3C-8.00851e-07 1.34315 1.34315 1.01469e-07 3 2.46316e-07L19 1.64508e-06C20.6569 1.78993e-06 22 1.34315 22 3L22 11C22 12.6569 20.6569 14 19 14Z",
  fill: "#189BC5"
});

var SvgAddRow = function SvgAddRow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddRow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_row.637dece2.svg";
export { ForwardRef as ReactComponent };